import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navyDeep px-4 py-12 text-center text-sm text-white/60" data-id="element-58" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-59" data-mp="3gg0xpz2xhpvj">
        <div className="mb-3 font-display text-xl font-black uppercase tracking-tight text-white" data-id="element-60" data-mp="32nulgo2wc31d">
          🏐 Gotowi na Siatkówkę
        </div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-61" data-mp="36q9354utwwr2">
          Kompletny, gotowy do użycia program treningu siatkówki dla trenerów, nauczycieli WF i klubów.
        </p>
        <nav aria-label="Informacje prawne" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-62" data-mp="37o74x94c1ef">
          <a href="#regulamin" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="3ldu3ir0bkhva">
            Regulamin
          </a>
          <a href="#polityka-prywatnosci" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-64" data-mp="29z6ss7ftibds">
            Polityka prywatności
          </a>
          <a href="#kontakt" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="2ezuvvrhbmiod">
            Kontakt
          </a>
        </nav>
        <p data-id="element-66" data-mp="3gah29wtj3p7f">© 2026 Gotowi na Siatkówkę — Wszelkie prawa zastrzeżone.</p>
      </div>
    </footer>;
}